import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Col, Pagination, Row } from 'antd/lib/index';
import moment from 'moment/moment';
import Rating from '../Rating';
import styles from './styles.less';
import { LocalizationContext } from '../../hoc/Localization';

const Reviews = ({ reviews }) => {
  const { t } = React.useContext(LocalizationContext);
  const [page, setPage] = React.useState(1);
  const showPerPage = 8;
  const totalPages = Math.ceil(reviews.length / showPerPage);

  const handlePageChange = value => {
    setPage(value);
  };

  return (
    <div id="reviewsContainer" className={styles.main}>
      <h2 className={styles.titleReview}>{t('course.comments.rates')}</h2>
      <div className={styles.container}>
        <Row type="flex" className={styles.row}>
          {reviews && reviews.length ? (
            reviews.slice((page - 1) * showPerPage, page * showPerPage).map(review => {
              const {
                user,
                createdAt,
                school_rating: rating,
                course_rating: courseRating,
                comment,
                id,
              } = review;

              return (
                <Col className={styles.col} md={24} key={id}>
                  <div className={styles.colContainer}>
                    <div className={styles.header}>
                      <div className={styles.profile}>
                        <Avatar
                          className={styles.avatar}
                          shape="circle"
                          src={
                            user
                              ? `http://graph.facebook.com/${user.providerId}/picture?type=square`
                              : ''
                          }
                        />

                        <div className={styles.name}>
                          <span>
                            {`${(user && user.firstName) || ''} ${(user && user.lastName) || ''}`}
                          </span>
                          <span>{moment(createdAt).format('MMM DD | hh:mm')}</span>
                        </div>
                      </div>

                      <div className={styles.rate}>
                        <Rating rating={rating || courseRating} />
                      </div>
                    </div>
                    {comment ? <div className={styles.content}>{comment}</div> : null}
                  </div>
                </Col>
              );
            })
          ) : (
            <div className={styles.noReviews}>{t('details.reviews.nodata')}</div>
          )}
        </Row>
        <div className={styles.pagination}>
          {reviews.length > showPerPage ? (
            <Pagination
              defaultCurrent={page}
              pageSize={1}
              total={totalPages}
              onChange={handlePageChange}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

Reviews.propTypes = {
  reviews: PropTypes.array,
};

Reviews.defaultProps = {
  reviews: [],
};

export default Reviews;
